import React from 'react';

export interface SignMin3IconProps {}

export const SignMin3Icon: React.FC<SignMin3IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.40146 5.20549C10.4216 5.19813 11.404 5.58053 12.1495 6.27126L12.2596 6.37717L16.222 10.3395L17.9432 6.73668C18.0622 6.48749 18.3606 6.38197 18.6098 6.50097C18.7712 6.57805 18.8791 6.73547 18.8929 6.9138L19.583 15.8823L10.6145 15.1922C10.3392 15.171 10.1331 14.9306 10.1543 14.6553C10.1681 14.477 10.276 14.3195 10.4374 14.2425L14.122 12.4825L10.1382 8.49849C9.96992 8.33017 9.74785 8.22811 9.51251 8.20891L9.42371 8.20562C8.89655 8.20953 8.46768 8.62066 8.43335 9.13836L8.43116 9.21301L8.49988 18.4777L5.49996 18.5L5.43102 9.23526C5.41486 7.02618 7.19238 5.22209 9.40146 5.20549Z"
        fill="#192033"
      />
    </svg>
  );
};
